import type { ReactNode } from 'react';

export function roleLabel(role?: string | null) {
  return { OWNER: 'Dueño', MANAGER: 'Gerente', EMPLOYEE: 'Empleado' }[role || ''] || 'Usuario';
}

export function EmptyState({ title, children }: { title: string; children: ReactNode }) {
  return <div className="empty-panel"><strong>{title}</strong><span>{children}</span></div>;
}

export function LoadingState({ children }: { children: ReactNode }) {
  return <div className="inline-loading"><span className="spinner" />{children}</div>;
}
